import Typography from '@mui/material/Typography';
import React, { useState } from "react";
import ShareIcon from '@mui/icons-material/Share';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';


const ShareCustom = ({ link }) => {
    const [showLess, setShowLess] = useState(true);
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }

        setOpen(false);
    };
    
    const action = (
        <React.Fragment>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );

    const copyToClipboard = (str) => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        setOpen(true)
    };
  
    return (
        <div>
            <IconButton onClick={() => copyToClipboard(link)} style={{alignItems: "right"}}>
                <ShareIcon />
            </IconButton>
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message="Link is copied!"
                action={action}
            />
        </div>
    );
};


  export default ShareCustom;